import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

const useCustomerContacts = (
  customerId,
  queryString,
  params = {},
  options = {}
) => {
  const [customerContacts, setCustomerContacts] = useState([])
  const [customerContactsCopy, setCustomerContactsCopy] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const [deletedContacts, setDeletedContacts] = useState([])

  const getCustomerContacts = () => {
    if (!customerId || options.skip) return Promise.resolve()

    if (customerId === 'new') {
      setCustomerContacts([])
      setCustomerContactsCopy([])
      setDeletedContacts([])
      setIsLoading(false)
      return Promise.resolve()
    }

    let url = `/api/customer/${customerId}/contact`

    if (queryString) url += `?name=${queryString}`

    Object.keys(params).forEach((key) => {
      const value = params[key]
      const char = url.includes('?') ? '&' : '?'
      url += `${char}${key}=${value}`
    })

    return authedAxios
      .get(url)
      .then((res) => {
        setIsLoading(false)
        setCustomerContacts(res.data.contacts)
        setCustomerContactsCopy(res.data.contacts)
      })
      .catch((e) => {
        setHasLoadError(true)
      })
  }

  const commitContact = (contact) => {
    const ids = customerContacts.map((c) => c.id)

    const index = ids.indexOf(contact.id)
    let newArr = [...customerContacts]

    if (contact.isDefault) {
      newArr = newArr.map((c) => ({ ...c, isDefault: false }))
    }

    if (index === -1) {
      const val = newArr.concat([contact])

      return saveContactsRequest(customerId, val, deletedContacts).then(
        (res) => {
          setCustomerContacts(val)
          return res
        }
      )
    }

    newArr.splice(index, 1, contact)

    return saveContactsRequest(customerId, newArr, deletedContacts).then(
      (res) => {
        setCustomerContacts(newArr)
        return res
      }
    )
  }

  const removeContact = (contact) => {
    const ids = customerContacts.map((c) => c.id)

    const index = ids.indexOf(contact.id)
    let newArr = [...customerContacts]
    newArr.splice(index, 1)
    setCustomerContacts(newArr)

    const newDeletedVal = !contact.isNew
      ? deletedContacts.concat([contact])
      : deletedContacts
    if (!contact.isNew) {
      setDeletedContacts(deletedContacts.concat([contact]))
      return saveContactsRequest(customerId, newArr, newDeletedVal)
    }
  }

  const saveContacts = (inId) => {
    const id = inId || customerId
    if (!id) return

    return saveContactsRequest(id, customerContacts, deletedContacts)
  }

  const saveContactsRequest = (id, contacts, deleted) => {
    const created = contacts.filter((c) => c.isNew)
    const edited = contacts.filter((c) => !c.isNew)

    return authedAxios
      .put(`/api/customer/${id || customerId}/contact`, {
        created,
        edited,
        deleted,
      })
      .then((res) => {
        getCustomerContacts().then(() => res)
      })
  }

  const reset = () => {
    setCustomerContacts(customerContactsCopy)
  }

  useEffect(() => {
    getCustomerContacts()
  }, [customerId, options?.skip])

  const primaryContact =
    customerContacts.find((c) => c.isDefault) || customerContacts[0]

  return {
    customerContacts,
    setCustomerContacts,
    isLoading,
    hasLoadError,
    getCustomerContacts,
    commitContact,
    removeContact,
    saveContacts,
    reset,
    primaryContact,
  }
}

export default useCustomerContacts
